module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0129.jpg?v=89352ffd";